import { render, staticRenderFns } from "./Pay2CoinDashboard.vue?vue&type=template&id=3801688a"
import script from "./Pay2CoinDashboard.vue?vue&type=script&lang=js"
export * from "./Pay2CoinDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports